<div class="container">
  <div class="item-component">
    <ion-label>{{ labelOne }}</ion-label>
    <ion-toggle
      mode="ios"
      [(ngModel)]="optionOneActive"
      (click)="switchActive(1)"
      (ionChange)="switchChange($event, 1)"
    ></ion-toggle>
  </div>
  <div class="item-component">
    <ion-label>{{ labelTwo }}</ion-label>
    <ion-toggle
      mode="ios"
      [(ngModel)]="optionTwoActive"
      (click)="switchActive(2)"
      (ionChange)="switchChange($event, 2)"
    ></ion-toggle>
  </div>
</div>
